import { render, staticRenderFns } from "./VitalFunctionsBase.vue?vue&type=template&id=17a5cc0d"
import script from "./VitalFunctionsBase.vue?vue&type=script&lang=js"
export * from "./VitalFunctionsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports